import React, { useState } from 'react';
import classes from "./checkout.module.css";
import { useNavigate } from 'react-router';
import DoubleArrow from "../../../assets/images/red-arrow.png";
import PromptMessage from '../../containers/promptMessage/promptMessage';
import { sixYardAxios } from '../../../sixYardAxios';

const Checkout = (props) => {
    const navigate = useNavigate();
    const amountAfterDiscount =
        ((Number(props.paymentData?.total_amount) || 0) -
            (Number(props.paymentDataWithMore?.seasonal_discount) || 0))
    const [loyaltyPointsUsed, setLoyaltyPointsUsed] = useState(0);
    const [partialValue, setPartialValue] = useState(Math.ceil(amountAfterDiscount * 0.5));
    const [loyalty, setLoyalty] = useState(0);
    const [checkLoyaltyEnteredAmount, setCheckLoyaltyEnteredAmount] = useState(null);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [totalAmount, setTotalAmount] = useState(amountAfterDiscount);
    const [paymentType, setPaymentType] = useState("partial");
    const [loading, setLoading] = useState(null);

    const calculateLoyaltyAmount = (e) => {
        if (e.target.value <= props.userData?.loyalty?.points) {
            setLoyalty(e.target.value);
        }
        else {
            setCheckLoyaltyEnteredAmount(props.currentLang === 'en' 
                ? "The amount you enter greater than your points"
                : "المبلغ الذي أدخلته أكبر من نقاطك");
        }
    }

    const closeLoyaltyIssue = () => {
        setCheckLoyaltyEnteredAmount(null)
        setLoyalty("");
    }

    const loyaltySubmitHandler = (e) => {
        e.preventDefault();
        setLoyaltyPointsUsed(loyalty)
        const newTotalAmount = amountAfterDiscount - loyalty;
        setTotalAmount(newTotalAmount)
        setPartialValue(Math.ceil(newTotalAmount * 0.5));
    }

    const submitHandler = async(e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.paymentData?.booking_id,
                amount: paymentType === "full" ? totalAmount : partialValue,
                payment_type: paymentType,
                loyalty_points_used: loyaltyPointsUsed,
                "customer_name": "",
                "customer_email": ""
            }
            const response = await sixYardAxios.post('/payments/initiate/field', formData);
            if (response.data.data) {
                const redirectUrl = response.data.data.redirect_url;
                localStorage.removeItem("TimeAndDateData");
                localStorage.removeItem("PersonalData");
                window.scrollTo({ top: 0, behavior: 'smooth' });
                
                if (redirectUrl != null) {
                    window.open(redirectUrl, '_blank');
                    navigate("/");
                } else {
                    setSuccess(props.currentLang === 'en' 
                        ? 'Booking completed successfully!'
                        : 'تم إكمال الحجز بنجاح!');
                    
                    setTimeout(() => {
                        navigate("/");
                    }, 5000);
                }
            };
        } catch (err) {
            setError(err.response?.data?.message || (props.currentLang === 'en' 
                ? 'Something went wrong. Please try again.'
                : 'حدث خطأ ما. يرجى المحاولة مرة أخرى.'));
        } finally {
            setLoading(false);
        }
    };

    const backHandler = () => {
        props.setCurrentStep(props.currentStep - 1);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <div className={classes.Container}>
            <div className={classes.Content}>
                <div className={classes.BookingSummery}>
                    <h3>{props.currentLang === 'en' ? 'Booking Summary' : 'ملخص الحجز'}</h3>
                    <div className={classes.info}>
                        <p>{props.timeAndDateData?.start_time} - {props.timeAndDateData?.end_time}, {props.timeAndDateData?.booking_date}</p>
                        <p>{props.location?.name}, {props.currentLang === 'en' ? 'Field Booking' : 'حجز الملعب'}</p>
                    </div>
                    <div>
                        {props.currentLang === 'en' 
                            ? `You have `
                            : 'لديك '}
                        <span className={classes.money}>{props.userData?.loyalty?.points} JD </span>
                        {props.currentLang === 'en'
                            ? 'from loyalty program, enter the amount you desire to use.'
                            : 'من برنامج الولاء، أدخل المبلغ الذي تريد استخدامه.'}
                    </div>
                    <form onSubmit={(e) => loyaltySubmitHandler(e)}>
                        <label>{props.currentLang === 'en' ? 'Amount' : 'المبلغ'}</label><br />
                        <input 
                            placeholder={props.currentLang === 'en' ? 'Enter amount' : 'أدخل المبلغ'} 
                            value={loyalty}
                            onChange={(e) => calculateLoyaltyAmount(e)} 
                        />
                        <button type='submit'>
                            {props.currentLang === 'en' ? 'Calculate' : 'احسب'}
                        </button>
                    </form>
                </div>
                <div className={classes.PaymentSummery}>
                    <h3>{props.currentLang === 'en' ? 'Payment Summary' : 'ملخص الدفع'}</h3>
                    {props.paymentDataWithMore?.base_price > 0 && <div>
                        <span>{props.currentLang === 'en' ? 'Original Amount' : 'المبلغ الأصلي'}</span>
                        <span>{props.paymentDataWithMore?.base_price} JD</span>
                    </div>}
                    {props.paymentDataWithMore?.referee_fee > 0 && <div>
                        <span>{props.currentLang === 'en' ? 'Referee Fee' : 'رسوم الحكم'}</span>
                        <span>{props.paymentDataWithMore?.referee_fee} JD</span>
                    </div>}
                    {props.paymentDataWithMore?.seasonal_discount > 0 && <div>
                        <span>{props.currentLang === 'en' ? 'Seasonal Discount' : 'خصم موسمي'}</span>
                        <span className={classes.Zero}>-{props.paymentDataWithMore?.seasonal_discount} JD</span>
                    </div>}
                    <div className={classes.LoyaltyPoints}>
                        <span>{props.currentLang === 'en' ? 'Loyalty Program Points' : 'نقاط برنامج الولاء'}</span>
                        <span className={classes.Zero}>{loyaltyPointsUsed === "" ? 0 : loyaltyPointsUsed} JD</span>
                    </div>
                    <div className={classes.Total}>
                        <span>{props.currentLang === 'en' ? 'Total' : 'المجموع'}</span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <h3>{props.currentLang === 'en' ? 'Payment Amount' : 'مبلغ الدفع'}</h3>
                    <div className={classes.Note}>
                        <div className={classes.NoteIcon}>i</div>
                        <div>
                            {props.currentLang === 'en' 
                                ? 'You can pay down payment or full amount'
                                : 'يمكنك دفع دفعة مقدمة أو المبلغ كاملاً'}
                        </div>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input 
                                type="radio" 
                                checked={paymentType === "partial"} 
                                value="partial"
                                onChange={() => setPaymentType("partial")} 
                            />
                            <label className={classes.Label}>
                                {props.currentLang === 'en' ? 'Down Payment' : 'دفعة مقدمة'}
                            </label>
                        </span>
                        <span>{partialValue} JD</span>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input 
                                type="radio" 
                                checked={paymentType === "full"} 
                                value="full"
                                onChange={() => setPaymentType("full")} 
                            />
                            <label className={classes.Label}>
                                {props.currentLang === 'en' ? 'Full Amount' : 'المبلغ كاملاً'}
                            </label>
                        </span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <form className={classes.FormContainer} onSubmit={(e) => submitHandler(e)}>
                        <div className={classes.Buttons}>
                            <button onClick={backHandler}>
                                <img
                                    src={DoubleArrow}
                                    alt=""
                                    className={[classes.Icon, props.currentLang === 'ar' ? classes.FlipArrow : ''].join(" ")}
                                /> {props.currentLang === 'en' ? 'BACK' : 'رجوع'}
                            </button>
                            <button type="submit">
                                {props.currentLang === 'en' ? 'CHECKOUT' : 'إتمام الدفع'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {error && 
                <PromptMessage 
                    message={error} 
                    status={props.currentLang === 'en' ? 'Oops' : 'عفواً'} 
                    button={props.currentLang === 'en' ? 'CLOSE' : 'إغلاق'} 
                    click={() => setError(false)} 
                />
            }
            {success && 
                <PromptMessage 
                    message={success} 
                    status={props.currentLang === 'en' ? 'SUCCESS' : 'تم بنجاح'} 
                    successMessage={true}
                    button={props.currentLang === 'en' ? 'CLOSE' : 'إغلاق'} 
                    click={() => {
                        setSuccess(null);
                        navigate("/");
                    }} 
                />
            }
            {checkLoyaltyEnteredAmount && 
                <PromptMessage 
                    message={checkLoyaltyEnteredAmount} 
                    status={props.currentLang === 'en' ? 'Oops' : 'عفواً'} 
                    button={props.currentLang === 'en' ? 'CLOSE' : 'إغلاق'} 
                    click={closeLoyaltyIssue} 
                />
            }
        </div>
    );
};

export default Checkout;